module.exports = __webpack_public_path__ + "static/logo_color-32c09400b9b5a49c447b1cb585a5eb96.svg";